import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const myTicketsRBAC = {
  pageID: 'f244177b8a621484664befa7f44e0940',
  elementID: {
    ViewPage: '4a572ddae18003164eaec5b3ca9af063',
    ButtonDetail: '38cd2ad7d6db25c9be5f5855aafa363e',
  },
} as const

export const useRBACMyTicketsPage = createUseRBAC(myTicketsRBAC.elementID)
export type UseRBACMyTicketsPageType = ReturnType<typeof useRBACMyTicketsPage>
